import { type FC, useMemo } from 'react'

import useRoleContext from 'app/KinerjaShared/hooks/useRoleContext'

type PageGuardPenilikPegawaiProps = React.HTMLAttributes<HTMLDivElement>

const PageGuardPenilikPegawai: FC<PageGuardPenilikPegawaiProps> = ({
  children,
}) => {
  const { isLoading: isLoadingRole, isPenilikPegawai, leave } = useRoleContext()

  const canAccess = useMemo(() => {
    let allowed = false

    // Allow if the user is Penilik SPNF
    if (isPenilikPegawai) allowed = true

    return allowed
  }, [isPenilikPegawai])

  if (!isLoadingRole && !canAccess) leave()

  // As the component should not be rendered when still loading the user role, we can just return null
  if (isLoadingRole) return null

  return <>{children}</>
}
export default PageGuardPenilikPegawai
